import React, { useState, useEffect } from 'react';
import { getPointsHistory } from '../services/api';
import './History.css';

function History() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await getPointsHistory();
      setTransactions(response.data);
    } catch (error) {
      console.error('Failed to fetch history:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTransactionIcon = (type) => {
    switch (type) {
      case 'earned':
        return '💰';
      case 'redeemed':
        return '🎁';
      case 'admin_added':
        return '⚡';
      default:
        return '📝';
    }
  };

  const getTransactionColor = (type) => {
    switch (type) {
      case 'earned':
      case 'admin_added':
        return 'positive';
      case 'redeemed':
        return 'negative';
      default:
        return 'neutral';
    }
  };

  const filteredTransactions = filter === 'all' 
    ? transactions 
    : transactions.filter(t => t.type === filter);

  if (loading) {
    return <div className="container"><div className="loading-spinner">Loading...</div></div>;
  }

  return (
    <div className="container history-page">
      <div className="page-header">
        <h1>📊 Points History</h1>
        <p>Track all your points transactions</p>
      </div>

      <div className="card">
        <div className="history-filters">
          <button 
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All Transactions
          </button>
          <button 
            className={`filter-btn ${filter === 'earned' ? 'active' : ''}`}
            onClick={() => setFilter('earned')}
          >
            Earned
          </button>
          <button 
            className={`filter-btn ${filter === 'redeemed' ? 'active' : ''}`}
            onClick={() => setFilter('redeemed')}
          >
            Redeemed
          </button>
        </div>

        {filteredTransactions.length === 0 ? (
          <div className="empty-state">
            <p>No transactions found</p>
          </div>
        ) : (
          <div className="transactions-list">
            {filteredTransactions.map(transaction => (
              <div key={transaction.id} className="transaction-item">
                <div className="transaction-icon">
                  {getTransactionIcon(transaction.type)}
                </div>
                
                <div className="transaction-details">
                  <h4>{transaction.reason}</h4>
                  <p className="transaction-date">
                    {new Date(transaction.timestamp).toLocaleString()}
                  </p>
                  {transaction.multiplier && transaction.multiplier > 1 && (
                    <span className="multiplier-badge">
                      {transaction.multiplier}x multiplier
                    </span>
                  )}
                </div>

                <div className={`transaction-points ${getTransactionColor(transaction.type)}`}>
                  {transaction.points > 0 ? '+' : ''}{transaction.points}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Summary Stats */}
      <div className="grid grid-3">
        <div className="stat-card">
          <h3>Total Earned</h3>
          <div className="stat-value positive">
            +{transactions
              .filter(t => t.points > 0)
              .reduce((sum, t) => sum + t.points, 0)}
          </div>
        </div>

        <div className="stat-card">
          <h3>Total Redeemed</h3>
          <div className="stat-value negative">
            {transactions
              .filter(t => t.points < 0)
              .reduce((sum, t) => sum + t.points, 0)}
          </div>
        </div>

        <div className="stat-card">
          <h3>Total Transactions</h3>
          <div className="stat-value neutral">
            {transactions.length}
          </div>
        </div>
      </div>
    </div>
  );
}

export default History;
